import PropTypes from 'prop-types'
import React, { useState } from 'react'
import TextField from 'ui/molecules/TextField'

import Icons from './Icons'

const iconClasses = 'text-gray-400 w-6 h-6'

function PasswordInput({ pencil, onIconClick, ...props }) {
  const [iconClicked, setIconClicked] = useState(false)

  function performIconClick() {
    if (onIconClick) {
      onIconClick()
    } else {
      setIconClicked(!iconClicked)
    }
  }

  const IconComponent = pencil ? (
    <Icons.Pencil className={iconClasses} />
  ) : iconClicked ? (
    <Icons.EyeOff className={iconClasses} />
  ) : (
    <Icons.Eye className={iconClasses} />
  )

  return (
    <TextField
      {...props}
      suffix={
        <button className="p-1 focus:outline-none" onClick={performIconClick}>
          {IconComponent}
        </button>
      }
      type={iconClicked ? 'text' : 'password'}
    />
  )
}

PasswordInput.defaultProps = {
  onChange: () => {},
  onBlur: () => {},
  onIconClick: null,
  disabled: false,
  value: '',
  placeholder: '',
  hasError: false,
  pencil: false,
  type: 'text',
}

PasswordInput.propTypes = {
  hasError: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onIconClick: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  errorLabel: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  type: PropTypes.string,
  pencil: PropTypes.bool,
}

export default PasswordInput
